export default __webpack_public_path__ + "static/media/resumePhoto.014bca90.png";